import React from 'react';
import {DateTime} from 'luxon';
import {Col, Row} from 'reactstrap';
import './TimerSection.scss';
import CountdownTimer from '../CountdownTimer';
import classNames from 'classnames';
import {usePhaseState} from 'funnel-schedule/phase-context';

export default function TntgCountdownSection({
  context = 'webinar',
  stacked = false,
  light = false,
  sales = false,
  salesTimerScreening = false,
  ...props
}) {
  const phases = usePhaseState().phases || {};
  const schedule = phases[context] || {};
  const {time, phase} = schedule;
  const isBefore = phase === 'before';
  const colSizes = !stacked ? {lg: '5', xl: '4'} : {};
  const countdownTime = time && DateTime.fromSeconds(time);
  const timerClass = sales || salesTimerScreening ? 'sales' : 'regular';
  return phase === 'replay' || (!sales && phase === 'before') ? (
    <div className={classNames('section-countdown text-center', props.className)}>
      <Row className="d-flex align-items-center justify-content-center m-0">
        <Col xs="12" {...colSizes} className={`p-0${light ? ' text-white' : ''}`}>
          <h3 className={`timer-heading-${timerClass} text-condensed text-800`}>
            {sales || salesTimerScreening ? (
              'Your special discount ends in:'
            ) : (
              <>
                {isBefore ? (
                  'The free viewing period begins in:'
                ) : (
                  <>
                    The free viewing <br className="d-none d-lg-block" />
                    period will end in:
                  </>
                )}
              </>
            )}
          </h3>
        </Col>
        <Col xs="12" {...colSizes} className={`timer p-0${!light ? ' countdown-dark' : ''}`}>
          <CountdownTimer time={isBefore ? countdownTime : countdownTime.plus({days: sales ? 5 : 4})} />
        </Col>
      </Row>
    </div>
  ) : null;
}
